export const userInfoMock = {
  // uuid: '1892406cf4b44322c8e86af18d940dfe',
  // ticket: 'F5D0CE3D303D3A0B9B19C2E235DAD6E0',
  // iscert: 1,
  // city: '',
  // banned: 0,
  // isValidated: 1,
  // isband: 1,
  // introduction: '',
  // logintype: 0,
  // accountState: 2,
}

export const deviceInfoMock = {
  // osVersion: '10.0.2',
  // gps: '',
  // ch: 'appstore',
  // time: '20181011110701',
  // pushSwitch: '0',
  // did: '1a84b178be125756396aa9632ac8015d21a582d2',
  // guid: '900000000889316400',
  // mf: 'Apple',
  // channel: 'AppStore',
  // appVersion: '6.0.4',
  // uuid: '87e5f27f917b4323b2af25c5462992fb',
  // rch: '',
  // sver: 'iphone-10.0.2',
  // ticket: 'BQGK0R8HD96IVM2D9RD0',
  // isdebug: 0,
  // IMEI: '',
  // aver: 'imgotv-iphone-6.0.4',
  // cid: '29a984f84d56fd80b5b2d17d821819cf',
  // net: 1,
  // sid: '91844BE7-EF6E-4B7B-A0C3-7E842BA7193D',
  // mac: '1a84b178be125750396ac9632ac8015d21a582d2',
  // mod: 'iPhone8_2',
  // rdc: '',
  // abroad: '0',
  // appBuildVersion: '6.0.4.1809211010',
  // p2p: '1',
  // dname: 'Jankerli%206S%2B',
  // reviewStatus: '0',
  // osType: 'ios',
  // device: 'iPhone',
  // idfa: 'B86073DA-5105-4FF1-84A8-FA1DCD9342DA',
}
